import { Field, FIELD_TYPES, Model } from "../../schema";

export default Model("group_state_model_field", {
    verbose_name: "Group State Model Field",
    verbose_name_plural: "Group State Model Fields",
    fields: [
        Field("id", {
            label: "ID",
            primary_key: true,
            readonly: true,
            hide: false,
            field_type: FIELD_TYPES.AutoNumber,
        }),

        Field("field_name", {
            label: "Field Name",
            primary_key: false,
            readonly: false,
            hide: false,
            required: false,
            field_type: FIELD_TYPES.String,
            default: () => {
                return null;
            },
        }),
        Field("deny_read", {
            label: "Deny Read",
            primary_key: false,
            readonly: false,
            hide: false,
            required: false,
            field_type: FIELD_TYPES.Boolean,
            default: () => {
                return false;
            },
        }),
        Field("deny_update", {
            label: "Deny Update",
            primary_key: false,
            readonly: false,
            hide: false,
            required: false,
            field_type: FIELD_TYPES.Boolean,
            default: () => {
                return false;
            },
        }),
    ],
});
